import s from "classnames";
import { useIntersection as o } from "next/dist/client/use-intersection";
import { getAnimationClassName as m } from "./getAnimationClassName.js";
function c(e) {
  const [i, t] = o({});
  if (!e)
    return [i, ""];
  const n = m(e);
  return [i, s(n, {
    "animated-block-initial": !t,
    "animated-block-visible": t
  })];
}
export {
  c as useAnimatedBlock
};
